import React from "react";
import { styled } from "@mui/system";
import MUIPagination from "@mui/material/Pagination";
import { PaginationProps as PaginationPropsMUI } from "@mui/material/Pagination";
export interface PaginationProps extends PaginationPropsMUI {}

export const Pagination: (props: PaginationProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, PaginationProps>((props, ref) => (
    <MUIPagination ref={ref} {...props} />
  )),
  {
    name: "Pagination",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiPagination-root	.MuiPagination-ul .MuiPaginationItem-root": {
    color: theme.palette.primary.main
  },
  "&.MuiPagination-root	.MuiPagination-ul .MuiPaginationItem-root.Mui-selected":
    {
      background: theme.palette.primary.baseVaporGradient,
      color: "white"
    },

  "&.MuiPagination-root	.MuiPagination-ul .MuiPaginationItem-previousNext": {
    color: theme.palette.primary.tertiaryTextDefault,
    background: theme.palette.primary.tertiaryBackgroundDefaultColor,
    borderRadius: 0,
    "&:hover,&:active,&:focus": {
      borderRadius: 0,
      background: theme.palette.primary.tertiaryBackgroundHoverColor,
      border: "transparent",
      color: theme.palette.primary.tertiaryTextHoverColor
    }
  }
}));
